<div class="status-container">
    <div class="flex justify-center">
        <h2 class="text-center page-heading flex">
            <span class="title">Site Monitoring</span>
            <!-- - ({{activeSites}} / {{totalSites}}) (active/total) -->
            <span class="flex">
                <span nz-tooltip nzTooltipTitle="Active Sites" class="status-block active"
                    style="display: flex;flex-direction: column;">
                    <span style="font-size:12px;">Active</span>
                    <span>{{activeSites}}</span>
                </span>
                <span nz-tooltip nzTooltipTitle="Down Sites" class="status-block down"
                    style="display: flex;flex-direction: column;">
                    <span style="font-size:12px;">Down</span>
                    <span>{{totalSites-activeSites}}</span>
                </span>
                <!-- <span nz-tooltip nzTooltipTitle="Total Sites" class="status-block total">
                    {{totalSites}}
                </span> -->
            </span>
        </h2>
        <nz-switch class="switch" [(ngModel)]="filter" (ngModelChange)="onFilterChange()" nzCheckedChildren="All Sites"
            nzUnCheckedChildren="Down Sites"></nz-switch>
        <!-- <span class="refresh" nz-tooltip nzTooltipTitle="Click to refresh" (click)="loadData()">
            <i class="fa-solid fa-arrows-rotate"></i>
            <span class="last-updated">Last refresh at: {{lastUpdated}}</span>
        </span> -->

    </div>


    <div class="de-admin-container flex">
        <ng-container *ngFor="let list of companiesData">
            <div class="gutter-row"
                *ngIf="customerWiseData[list.id] && customerWiseData[list.id].sites && customerWiseData[list.id].sites.length">
                <div class="list">
                    <h2 class="heading">
                        {{ list.name }}
                        <span style="font-size: 14px;">({{list.id}})</span>
                        <span class="status" *ngIf="customerwiseActive && customerwiseActive[list.id]">
                            <span nz-tooltip nzTooltipTitle="Active Sites" class="status-block active">

                                {{customerwiseActive[list.id].active}}</span>
                            <span nz-tooltip nzTooltipTitle="Down Sites"
                                class="status-block down">{{customerwiseActive[list.id].total-customerwiseActive[list.id].active}}</span>
                            <!-- <span nz-tooltip nzTooltipTitle="Total Sites" class="status-block total">
                                {{customerwiseActive[list.id].total}}
                            </span> -->
                        </span>
                    </h2>
                    <div class="body">
                        <div class="list site-list" [class.down]="site.d"
                            *ngFor="let site of customerWiseData[list.id].sites">

                            <div class="relative">
                                <span nz-tooltip [nzTooltipTitle]="site.d?'Site down':'Site active'"
                                    class="status-circle" [class.down]="site.d"></span>
                                <span *ngIf="site.r" style="padding-right: 4px;">
                                    <fa-icon *ngIf="site.r==='s'" nz-tooltip nzTooltipTitle="Solar"
                                        [icon]="faSolarIcon"></fa-icon>
                                    <fa-icon *ngIf="site.r==='w'" nz-tooltip nzTooltipTitle="Wind"
                                        [icon]="faWindIcon"></fa-icon>

                                </span>
                                <span class="site-name">{{site.s}}</span>
                                ({{site.siteId}})<!-- &nbsp;<span class="site-id">{{site.siteId}}</span> -->

                            </div>
                            <div class="last-uptdated">Last Updated: {{site.time}}</div>
                        </div>
                        <!-- <button nz-button class="button custom-button " style="cursor: pointer" routerLink="{{ list.id }}">
                            Show Sites
                        </button> -->
                    </div>
                </div>
            </div>
        </ng-container>

        <div style="min-width: 10px;height: 10px;"></div>

    </div>
</div>